// Generated from src/locales/lang/zh.js.
export default {
  "请输入手机号或用户名": "Please enter your mobile phone number or username",
  "请输入密码": "Please enter password",
  "自动登录": "Automatic login",
  "游戏试玩": "Game trial",
  "忘记密码": "forget the password",
  "登录账户": "Login account",
  "联系客服": "Contact customer service",
  "注册账户": "Register an account",
  "请选择你的语言": "Please choose your language",
  "选择你的语言": "Choose your language",
  "英语": "English",
  "简体中文": "Simplified Chinese",
  "繁体中文": "Traditional Chinese",
  "请输入确认密码": "Please enter the confirmation password",
  "推荐人": "recommender",
  "请输入验证码": "Please enter the verification code",
  "注册": "register",
  "登录": "Log in",
  "返回登录": "Return to login",
  "复制成功": "Copied successfully",
  "客服": "customer service",
  "大厅": "Home",
  "发现": "Discover",
  "优惠": "discount",
  "我的": "Me",
  "会话": "session",
  "公告通知": "Announcements",
  "上下分如有问题请及时联系客服": "If you have any questions, please contact customer service in time",
  "在线客服": "Online customer service",
  "提供各类问题疑难排解": "Provide troubleshooting for various issues",
  "Telegram客服": "Telegram customer service",
  "Signal客服": "Signal customer service",
  "Signal客服号码": "+1(971) 427 1149",
  "消息中心": "Message center",
  "公告": "announcement",
  "站内信": "Site message",
  "没有更多了": "no more",
  "请先登录或者注册": "Please log in or register first",
  "充值": "Recharge",
  "转账": "transfer",
  "提现": "Withdraw",
  "IOS用户注意": "Attention iOS users",
  "尊敬的U8会员您好": "Dear U8 members, hello",
  "系统内容1": "The new version of U8 International iOS APP has been repaired and officially launched, and is now available for download.",
  "系统内容2": "However, in order to ensure permanent access and stable access, it is recommended that you use Safari browser to open it first.",
  "系统内容3": "Click the 📤 \"Share\" button at the bottom → select \"Add to Home Screen\" to quickly enter the platform.",
  "系统内容4": "If you want to use the APP, please go to the official website",
  "系统内容5": "On the home page, click the [Click to Download] button in the upper right corner to get the latest version.",
  "系统内容6": "If you have any questions, please contact official customer service",
  "系统内容7": "Assist with processing.",
  "系统内容8": "Thank you for your support and understanding!",
  "系统内容9": "U8 international operations team",
  "公平": "fair",
  "公正": "just",
  "公开": "public",
  "官方投注机器人": "Official Betting Robot",
  "系统内容10": "Directly perform operations such as games, recharges, and withdrawals.",
  "搜索": "search",
  "系统内容11": "Thank you for your understanding and support, and I wish you a happy game!",
  "今日不再弹出": "Don’t pop up again today",
  "添加": "Add to",
  "到手机主页屏幕": "Go to the phone home screen",
  "选择分享按钮": "Go to the phone home screen",
  "点击": "Click",
  "加至主画面": "Add to home screen",
  "点击「加入」按钮": "Click the \"Join\" button",
  "存款": "deposit",
  "网银转账": "Online banking transfer",
  "微信": "WeChat",
  "支付宝": "Alipay",
  "收款账号": "Payment account number",
  "复制": "copy",
  "银行户名": "Bank account name",
  "开户行": "Account opening bank",
  "银行地址": "bank address",
  "开户银行": "Bank of deposit",
  "选择开户银行": "Choose your bank",
  "存款人姓名": "Depositor's name",
  "请输入存款人姓名": "Please enter the depositor's name",
  "请务必输入正确的存款人姓名": "To ensure timely payment, please be sure to enter the correct name of the depositor",
  "银行卡号": "Bank card number",
  "请输入银行卡号": "Please enter bank card number",
  "开户行地址": "Account opening bank address",
  "请输入开户行地址": "Please enter the account opening bank address",
  "请输入银行开户行地址": "Please enter the bank account address",
  "存款金额": "Deposit amount",
  "请输入取款金额": "Please enter the withdrawal amount",
  "元": "Yuan",
  "USDT价格稳定": "USDT price is stable",
  "流通性高": "High liquidity",
  "不受监管": "Unregulated",
  "了解更多": "learn more",
  "绑定协议地址": "Binding protocol address",
  "交易所划转": "Exchange transfer",
  "完成取款": "Complete withdrawal",
  "钱包协议": "wallet protocol",
  "温馨提示": "Kind tips",
  "温馨提示内容": "Please choose the correct USDT protocol for payment. If you choose the wrong protocol for payment, the platform will not be able to receive your payment, and we do not assume any responsibility for this!",
  "立即存款": "Deposit now",
  "存款遇到问题": "Problem with deposit",
  "联系": "connect",
  "人工客服": "Human customer service",
  "解决": "solve",
  "银行类型": "Bank type",
  "请输入银行类型": "Please enter bank type",
  "请输入金额区间": "Please enter the amount between {min_price}-{max_price}!",
  "等待后台审核": "Submission successful, waiting for background review",
  "场馆转账": "Venue transfer",
  "余额自动转入": "Balance automatically transferred",
  "启用后余额自动转入转出游戏场馆": "After activation, the balance will be automatically transferred into and out of game venues.",
  "请输入转账金额": "Please enter the transfer amount",
  "全部转入": "Transfer all",
  "可转账金额": "Transferable amount",
  "确认转账": "Confirm transfer",
  "场馆余额明细": "Venue balance details",
  "点击查看全部场馆余额": "Click to view all venue balances",
  "主钱包": "main wallet",
  "一键取回": "Retrieve with one click",
  "收起": "close",
  "展开": "Expand",
  "请输入操作金额": "Please enter the operation amount",
  "场馆内钱包不支持互转": "Wallets within the venue do not support mutual transfers",
  "操作成功": "Operation successful",
  "VIP特权": "VIP privileges",
  "已达标": "Already achieved",
  "未达标": "Not up to standard",
  "累计存款": "Accumulated deposits",
  "流水要求": "Running requirements",
  "VIP最高返水比例": "VIP highest rebate ratio",
  "VIP等级": "VIP level",
  "真人": "real person",
  "体育": "physical education",
  "电竞": "eSports",
  "棋牌": "chess and cards",
  "电子": "electronic",
  "彩票": "Lottery",
  "活动规则": "Activity rules",
  "晋升标准": "Promotion criteria",
  "规则内容1": "Members whose accumulated deposits and accumulated turnover meet the requirements of the corresponding level can be promoted to the corresponding VIP level before 24:00 the next day.",
  "晋升顺序": "Promotion order",
  "规则内容2": "If the VIP level meets the corresponding requirements, you can be promoted to one level every day, but the VIP level cannot be promoted beyond the next level.",
  "保级要求": "Relegation requirements",
  "规则内容3": "After a member reaches a certain VIP level, he or she must complete the maintenance requirements for betting within 90 days. If promotion is completed during this period, relegation requirements will be recalculated based on the current level.",
  "降级标准": "downgrade criteria",
  "规则内容4": "If a member does not complete the corresponding level maintenance requirements within a quarter (calculated in 90 days), the system will automatically downgrade one level, and the corresponding rebates and other benefits will also be adjusted to the downgraded level.",
  "VIP返水": "VIP rebate",
  "规则内容5": "The amount of the VIP rebate discount is calculated based on the member’s valid bets between 00:00 and 23:59 Beijing time on the day. All rebates for the day’s bets will be distributed to the Welfare Center within 24 hours after the end of the day when the bet is settled. Go to the Personal Center and click on the Welfare Center to collect it manually. (VIP rebates can be withdrawn with 1x turnover)",
  "规则内容6": "Opel Entertainment reserves the right to modify, stop and final explanation of the event",
  "取款": "Withdraw money",
  "银行卡取款": "Bank card withdrawal",
  "钱包金额": "Wallet amount",
  "一键回收": "One-click recycling",
  "中心钱包": "central wallet",
  "游戏钱包": "Game wallet",
  "选择USDT地址": "Select USDT address",
  "请选择USDT地址": "Please select a USDT address",
  "添加USDT地址": "Add USDT address",
  "打码量": "Amount of coding",
  "取款金额": "Withdrawal amount",
  "最大金额": "maximum amount",
  "支付密码": "Payment password",
  "请输入支付密码": "Please enter payment password",
  "每笔手续费": "Each transaction fee",
  "折合USDT": "Converted to USDT",
  "参考汇率": "reference exchange rate",
  "实时变化": "real-time changes",
  "实际到账": "Actual arrival",
  "选择银行卡": "Select bank card",
  "请选择银行卡": "Please select a bank card",
  "添加银行卡": "Add bank card",
  "立即取款": "Withdraw money now",
  "取款遇到问题": "Problem with withdrawing money",
  "真实姓名": "real name",
  "绑定真实姓名后不可修改": "Once the real name is bound, it cannot be modified.",
  "确认修改": "Confirm changes",
  "请选择您要提现到的银行卡": "Please select the bank card you want to withdraw money to",
  "单笔取款不能低于100元": "A single withdrawal cannot be less than 100 yuan",
  "请输入您的支付密码": "Please enter your payment password",
  "请填写用户实名信息": "Please fill in the user’s real name information",
  "提交成功": "Submission successful",
  "优惠活动": "Promotions",
  "全部优惠": "All offers",
  "限时活动": "limited time event",
  "新人首存": "First deposit for new users",
  "日常活动": "daily activities",
  "暂未设置签名": "No signature has been set yet",
  "账户总资产": "Total account assets",
  "我的钱包": "Wallet",
  "账户明细": "Account details",
  "投注记录": "Betting records",
  "安全设置": "Security settings",
  "我的等级": "my level",
  "VIP中心": "VIP center",
  "邀请好友": "Invite friends",
  "推荐送礼金": "Recommended gift money",
  "官方公告": "Official announcement",
  "坐收盈利": "Collect profits",
  "合营计划": "joint venture plan",
  "加入我们": "Join us",
  "月入百万": "One million monthly income",
  "NG扑克": "NG Poker",
  "活动中心": "activity center",
  "平台优惠回馈活动": "Platform discounts and feedback activities",
  "输赢比例": "Profit Records",
  "功能设置": "Function settings",
  "反水比例": "Return ratio",
  "反水中心": "Counterfeit Center",
  "修改登录密码": "Change login password",
  "个人资料": "personal information",
  "个人头像": "profile picture",
  "用户名": "username",
  "请输入用户名": "Please enter username",
  "请输入真实姓名": "Please enter your real name",
  "出生日期": "date of birth",
  "请选择出入日期": "Please select a check-in and check-out date",
  "手机号码": "phone number",
  "绑定手机号保障账号安全": "Bind mobile phone number to ensure account security",
  "电子邮箱": "Email",
  "绑定邮箱保护账号安全": "Bind email to protect account security",
  "请输入正确手机号": "Please enter the correct mobile phone number",
  "请输入正确邮箱号": "Please enter the correct email number",
  "请输入正确的日期格式": "Please enter the correct date format",
  "邀请链接": "Invitation link",
  "立即邀请": "Invite now",
  "礼金介绍": "Introduction to gift money",
  "明细记录": "Detailed records",
  "下级概览": "Lower level overview",
  "下级成员统计": "Subordinate member statistics",
  "本月新增": "New this month",
  "本月活跃成员": "Active members this month",
  "本月有效活跃": "Effectively active this month",
  "今日新增": "New today",
  "今日活跃": "Active today",
  "本月新增有效会员": "New valid members added this month",
  "今日存款": "Deposit today",
  "数据列表": "Data list",
  "礼金记录": "Gift record",
  "好友明细": "Friends details",
  "重置": "reset",
  "查询": "Query",
  "日期": "date",
  "礼金": "gift money",
  "备注": "Remark",
  "保存链接": "save link",
  "保存图片": "save image",
  "保存二维码": "Save QR code",
  "取消": "Cancel",
  "链接已复制到剪贴板": "Link copied to clipboard",
  "复制链接失败": "Failed to copy link",
  "合营部": "Joint venture department",
  "立即咨询": "Consult now",
  "咨询": "consult",
  "联系方式": "Contact information",
  "请输入您的联系方式": "Please enter your contact information",
  "申请理由": "Reasons for application",
  "请输入申请理由": "Please enter the reason for application",
  "盈利总额": "Total profit",
  "充值总额": "Total recharge",
  "提现总额": "Total withdrawal amount",
  "投注总额": "total bet",
  "设置": "set up",
  "消息时间显示": "Message time display",
  "中奖提示": "Winning Tips",
  "安静模式": "Quiet mode",
  "关于CG": "About CG",
  "帮助与反馈": "Help and feedback",
  "退出": "quit",
  "返水比例": "Rebate ratio",
  "当日累计投注": "Accumulated bets on the day",
  "转运金": "transfer fee",
  "开元棋牌": "Kaiyuan chess and cards",
  "设置提现密码": "Set withdrawal password",
  "原密码": "Original password",
  "请输入当前密码": "Please enter current password",
  "新密码": "New Password",
  "请输入新密码": "Please enter new password",
  "确认新密码": "Confirm new password",
  "请再次输入密码": "Please enter password again",
  "请输入旧密码": "Please enter old password",
  "请输入正确的旧密码长度": "Please enter the correct old password length",
  "请输入正确的新密码长度": "Please enter the correct new password length",
  "两次密码不一致": "Two passwords are inconsistent",
  "新旧密码不能一致": "The old and new passwords cannot be consistent",
  "密码修改成功": "Password changed successfully",
  "app下载": "app download",
  "可扫描下发二维码进行app下载": "Scan the QR code to download the app",
  "立即下载": "Download now",
  "下载说明": "It needs to be downloaded, installed and registered in the same network environment, please do not switch networks; if it cannot be installed normally, please use the browser that comes with your phone to open this page",
  "请输入金额": "Please enter the amount",
  "转入": "transfer in",
  "平台钱包": "Platform wallet",
  "操作金额不能为0": "The operation amount cannot be 0",
  "转入成功": "Transfer successful",
  "天": "sky",
  "时": "hour",
  "分": "point",
  "秒": "Second",
  "剩余领取次数": "Remaining number of collections",
  "次": "Second-rate",
  "主账号余额": "Main account balance",
  "账户充值": "Account recharge",
  "账户提现": "Account withdrawal",
  "下线转账": "Offline transfer",
  "订单号": "Order number",
  "金额": "Amount",
  "空空如也": "Empty",
  "今日": "today",
  "近7日": "Last 7 days",
  "近15日": "Last 15 days",
  "近30日": "Nearly 30 days",
  "转出": "transfer out",
  "赠送": "give away",
  "反水": "Betrayal",
  "未定义": "undefined",
  "待审核": "Pending review",
  "审核通过": "Approved",
  "审核拒绝": "Review rejection",
  "失败": "fail",
  "成功": "success",
  "待结算": "Pending settlement",
  "全平台": "All platforms",
  "大舞台": "big stage",
  "官方动态": "Official news",
  "动态": "dynamic",
  "活动申请记录": "Activity application record",
  "活动标题": "Event title",
  "申请时间": "Application time",
  "状态": "state",
  "未约定": "Not agreed",
  "通过": "pass",
  "拒绝": "reject",
  "派彩": "payout",
  "无效注单": "Invalid bet",
  "已结算": "Settled",
  "未结算": "Unsettled",
  "返水中心": "Rebate Center",
  "返水记录": "Cashback record",
  "点击领取": "Click to claim",
  "累计领取": "Accumulated collection",
  "待领取": "To be collected",
  "返水金额": "Rebate amount",
  "返水时间": "Rebate time",
  "领取时间": "Collection time",
  "暂未领取": "Not collected yet",
  "暂无领取额度": "No amount available yet",
  "加载中": "loading",
  "最多支持添加5个地址": "Supports adding up to 5 addresses",
  "认证失败": "Authentication failed",
  "您的账号登陆过期，请重新登陆": "Your account login has expired, please log in again",
  "提示": "hint",
  "您确定要退出登录吗": "Are you sure you want to log out?",
  "精彩内容等你来体验，快来登录吧": "Wonderful content is waiting for you to experience, come and log in",
  "立即下载APP": "Download the APP now",
  "余额": "balance",
  "活动详情": "Event details",
  "活动说明": "Activity description",
  "立即申请": "Apply now",
  "前往登录": "Go to login",
  "代理系统": "agent system",
  "下属代理": "Subordinate agent",
  "代理总览": "Agency Overview",
  "直属玩家": "Direct player",
  "盈亏统计": "Profit and loss statistics",
  "账单查询": "Bill inquiry",
  "充值记录": "Recharge record",
  "提现记录": "Withdrawal records",
  "个人信息": "personal information",
  "下级在线": "Subordinates online",
  "我的余额": "my balance",
  "附属代理人": "affiliated agent",
  "附属玩家": "Affiliated players",
  "今日投注": "Betting today",
  "今日收入": "Today's income",
  "历史收入": "Historical revenue",
  "邀请码": "Invitation code",
  "开盘中": "Opening",
  "已封盘": "Closed",
  "下注倒计时": "Bet countdown",
  "期": "Expect",
  "期开奖结果": "Lottery results",
  "已开启": "Already turned on",
  "已关闭": "Closed",
  "期号": "Issue number",
  "号码": "Number",
  "总和": "sum",
  "总和两面": "The sum of both sides",
  "首页": "front page",
  "上一页": "Previous page",
  "下一页": "Next page",
  "尾页": "Last page",
  "请输入": "Please enter",
  "下注": "Place a bet",
  "选择": "Select",
  "大小单双": "Size single and double",
  "大": "Big",
  "小": "Small",
  "单": "Odd",
  "双": "Even",
  "大单": "Big Odd",
  "大双": "Big Even",
  "小单": "Small Odd",
  "小双": "Small Even",
  "形态": "form",
  "豹子": "leopard",
  "对子": "Pair",
  "顺子": "straight",
  "极大": "Extreme Big",
  "极小": "Extreme Small",
  "特码": "Special code",
  "清空": "Clear",
  "立即下注": "Place your bet now",
  "开奖号码": "Lottery numbers",
  "第": "No.",
  "投注时间": "Betting time",
  "投注金额": "Bet amount",
  "玩法": "How to play",
  "盘类": "disk type",
  "派奖奖金": "Prize money",
  "赔率": "Odds",
  "双面玩法": "Double-side",
  "特码玩法": "Special Number",
  "倍": "x",
  "投注积分": "Bet Points",
  "请输入投注积分": "Enter bet points",
  "返水": "rebate",
  "总投注": "total bet",
  "有效投注": "Valid bet",
  "实际盈利": "Actual profit",
  "两面": "both sides",
  "组合": "combination",
  "每页": "per page",
  "条": "strip",
  "编辑金额": "Edit amount",
  "恢复默认": "Restore default",
  "保存": "save",
  "距离开奖": "Distance to lottery draw",
  "刷新": "refresh",
  "返回": "return",
  "当前第": "Current No.",
  "数据统计详情": "Statistics details",
  "值": "value",
  "未开期数": "Number of open periods",
  "单路区": "one way area",
  "间隔": "interval",
  "咪牌": "Mi brand",
  "投注区": "betting area",
  "游戏记录": "Game records",
  "路单区": "Ludan District",
  "游戏规则": "game rules",
  "开奖验证": "Lottery verification",
  "开奖记录": "Lottery results",
  "统计": "statistics",
  "大小": "size",
  "极大小": "Extremely small",
  "已选": "Selected",
  "注": "Note",
  "共计": "total",
  "已中奖": "Won",
  "未开奖": "Not drawn yet",
  "已退款": "Refunded",
  "语言": "language",
  "六合彩": "Mark Six Lottery",
  "初级": "primary",
  "猜特码": "Guess the special code",
  "猜特肖": "Chaitshaw",
  "猜平肖": "Guess Pinxiao",
  "猜类型": "Guess the type",
  "平肖": "Pinchot",
  "鼠": "mouse",
  "牛": "ox",
  "虎": "Tiger",
  "兔": "rabbit",
  "龙": "dragon",
  "蛇": "snake",
  "马": "horse",
  "羊": "sheep",
  "猴": "monkey",
  "鸡": "chicken",
  "狗": "dog",
  "猪": "pig",
  "类型": "type",
  "蓝波": "blue wave",
  "绿波": "green wave",
  "红波": "red wave",
  "特肖": "Special Shaw",
  "特鼠": "special rat",
  "特牛": "Special cow",
  "特虎": "special tiger",
  "特兔": "special rabbit",
  "特龙": "Tron",
  "特蛇": "special snake",
  "特马": "Tema",
  "特羊": "special sheep",
  "特鸡": "Special chicken",
  "特狗": "special dog",
  "特猪": "special pig",
  "特猴": "Special monkey",
  "什么也没有": "nothing",
  "进行中": "in progress",
  "已结束": "ended",
  "快捷下注": "Quick betting",
  "开奖走势": "Lottery trend",
  "开奖历史": "Lottery history",
  "在线": "online",
  "快捷投注": "Quick betting",
  "项": "item",
  "需支付": "Need to pay",
  "确认投注": "Confirm bet",
  "错误提示": "Error message",
  "管理员": "administrator",
  "封盘中": "Closed",
  "预计盈利": "expected profit",
  "投注成功": "bet successful",
  "用户": "user",
  "时间": "time",
  "投注": "Bet",
  "MI28": "MI28",
  "中级": "intermediate",
  "新澳门六合彩": "New Macau Mark Six Lottery",
  "澳门六合彩": "Macau Mark Six Lottery",
  "下注内容": "Bet content",
  "合计总金额": "Total amount",
  "房间": "Room",
  "投注详情": "Bet details",
  "输赢": "Win/Loss",
  "开奖结果": "Draw result",
  "当期总输赢": "Current round win/loss",
  "开奖时间": "Draw time",
  "更多新玩法等你来体验": "More new ways to play are waiting for you to experience",
  "精彩活动": "Wonderful activities",
  "代理联盟": "Agency Alliance",
  "始于成功": "Start with success",
  "臻于卓越": "Reach for excellence",
  "鲤跃龙门": "Carp leaping over the dragon gate",
  "投资传奇": "Investment legend",
  "VIP会员成长": "VIP membership growth",
  "晋级VIP会员": "Become a VIP member",
  "享顶级至尊服务": "Enjoy top-notch services",
  "确认添加": "Confirm to add",
  "iOS用户注意": "Attention iOS users",
  "充值打码量": "Deposit wagering requirement",
  "全部": "All",
  "划转": "Transfer",
  "协议的区别": "Protocol differences",
  "开奖中": "Drawing in progress",
  "新增USDT地址": "Add USDT address",
  "新增银行卡": "Add bank card",
  "本月存款": "Deposits this month",
  "游戏大厅": "Game hall",
  "玩法介绍": "How to play",
  "账户": "Account",
  "赠送打码量": "Bonus wagering requirement",
  "搜索游戏名称": "Search games",
  "请登录": "Please log in",
  "红包已关闭": "Red packet is closed",
  "已在当前页面": "Already on this page",
  "马克六号彩票": "Mark Six Lottery",
  "PC28高赔率": "MI28 High Odds",
  "PC28": "MI28",
  "发送的消息不能为空": "Message cannot be empty",
  "19:56:30～20:29:30 为维护时间": "Maintenance: 19:56:30-20:29:30",
  "23:55:30～00:05:00 为维护时间": "Maintenance: 23:55:30-00:05:00",
  "本期已封盘": "This round is closed",
  "发送成功": "Sent successfully",
  "请选择玩法": "Please select a bet type",
  "请选择金额": "Please select an amount",
  "恢复成功": "Restored successfully",
  "价格不能为空值或0": "Price cannot be empty or zero",
  "价格不能有重复": "Prices cannot be duplicated",
  "持卡人姓名": "Cardholder name",
  "请输入持卡人姓名": "Please enter the cardholder name",
  "为了您的资金能够迅速到账，请确保填写的姓名与银行卡的开户姓名一致": "For fast processing, make sure the name matches the bank account holder.",
  "请选择银行类型": "Please select the bank type",
  "请输入开户行": "Please enter the bank branch",
  "请输入姓名": "Please enter a name",
  "请输入银行": "Please enter the bank",
  "请输人银行卡号": "Please enter your bank card number",
  "请输人支付密码": "Please enter your payment password",
  "请输人正确的卡号长度": "Please enter a card number of the correct length",
  "请输人支付密码长度": "Please enter a payment password of the correct length",
  "绑定成功": "Bound successfully",
  "USDT地址": "USDT address",
  "请输入USDT地址": "Please enter the USDT address",
  "请选择钱包协议": "Please select a wallet protocol",
  "赠送记录": "Gift records",
  "选择开始日期": "Select start date",
  "选择结束日期": "Select end date",
  "输入账号": "Enter account",
  "昵称": "Nickname",
  "赠送前": "Before gift",
  "赠送后": "After gift",
  "赠送金额": "Gift amount",
  "到账状态": "Settlement status",
  "直属代理": "Direct agents",
  "自己": "Self",
  "请先选择开始时间": "Please select a start time first",
  "团队总人数": "Total team members",
  "团队总彩金": "Total team bonuses",
  "团队总充值": "Total team deposits",
  "团队总输赢": "Total team wins/losses",
  "团队总投注": "Total team bets",
  "团队纯利": "Team net profit",
  "团队福利": "Team benefits",
  "新注册人数": "New registrations",
  "首充人数": "First-deposit members",
  "团队返水": "Team rebate",
  "团队拥金返水": "Team commission rebate",
  "六合盈亏": "Liuhe profit and loss",
  "金币": "Coins",
  "总盈利": "Total profit",
  "直属": "Direct",
  "所在房间": "Current room",
  "代理": "Agent",
  "暂无数据": "No data",
  "MI28按照加拿大卑斯快乐8的开奖结果为基础": "MI28 is based on the results of Canada BC Keno.",
  "每日官网维护时间是18:56-19:33": "Daily website maintenance: 18:56-19:33",
  "每3.5分钟公布一次加拿大卑斯快乐8开奖结果": "Canada BC Keno results are published every 3.5 minutes.",
  "排序后分别按号码": "Sort by number",
  "第1-6，7-12，13-18分为【1】【2】【3】三个区": "Numbers 1-6, 7-12 and 13-18 form zones 1, 2 and 3.",
  "赔率全新升级！ 单注1起，总注500000封顶。大小单双100000封顶。组合50000封顶。": "New odds! Single bets start at 1; total bets are capped at 500,000, Big/Small and Odd/Even at 100,000, and combinations at 50,000.",
  "特码20000封顶。2值10000封顶。 大小单双2.0倍（含本金）。【组合:小单/大双4.6倍；小双/大单4.2倍】（含本金）。": "Special number limit: 20,000. Two-number limit: 10,000. Big/Small and Odd/Even pay 2.0x including stake; combinations pay 4.6x or 4.2x including stake.",
  "注：大小单双开13/14特殊赔率": "Note: Big/Small and Odd/Even have special odds when 13 or 14 is drawn.",
  "总注：4999以内1.6倍（含本金）": "Total bets up to 4,999: 1.6x including stake.",
  "总注：9999以内1.2倍（含本金）": "Total bets up to 9,999: 1.2x including stake.",
  "总注：30000以上吃下注本金": "Total bets above 30,000: the stake is retained.",
  "组合：29999以内小单，大双 开13，14赔率回本（含本金）！": "Combination: up to 29,999, Small Odd or Big Even; 13 and 14 return the stake.",
  "组合：30000以上吃下注本金": "Combination bets above 30,000 retain the stake.",
  "豹子-顺子-对子-玩法": "Triples, straights and pairs",
  "豹子48倍": "Triples: 48x",
  "顺子10倍": "Straights: 10x",
  "对子3倍": "Pairs: 3x",
  "极值15倍": "Extreme: 15x",
  "回水规则": "Rebate rules",
  "1、负分3600.000-36000.000 需下注把数10吧 反百分之3": "1. For a negative balance of 3,600-36,000, place 10 bets to receive a 3% rebate.",
  "2、负分36000.000-100000.000需下注把数10把 反百分之5": "2. For a negative balance of 36,000-100,000, place 10 bets to receive a 5% rebate.",
  "3、负分100000.000需下注把数10把 反百分之8": "3. For a negative balance above 100,000, place 10 bets to receive an 8% rebate.",
  "【MI28】规则说明": "MI28 rules",
  "1.大小玩法 数字14-27为大 数字0-13为小 。": "1. Big/Small: numbers 14-27 are Big; numbers 0-13 are Small.",
  "2.单双玩法": "2. Odd/Even bets",
  "数字1，3，5，~27为单 数字0，2，4~26为双。": "Numbers 1, 3, 5 to 27 are Odd; numbers 0, 2, 4 to 26 are Even.",
  "3.极值玩法": "3. Extreme numbers",
  "极小：0，1，2，3，4，5": "Extreme Small: 0, 1, 2, 3, 4, 5",
  "极大：22，23，24，25，26，27": "Extreme Big: 22, 23, 24, 25, 26, 27",
  "举例：买极小 开奖结果为0-5其中一个数字就中奖，买极大开奖结果为22-27其中一个数字就中奖。": "Example: Extreme Small wins when the result is 0-5; Extreme Big wins when the result is 22-27.",
  "4.组合玩法": "4. Combination bets",
  "* 数字14，16，~26为大双； 数字0，2，4，~12为小双。": "* Numbers 14, 16 to 26 are Big Even; numbers 0, 2, 4 to 12 are Small Even.",
  "* 数字15，17，~27为大单； 数字1，3，5，~13为小单。": "* Numbers 15, 17 to 27 are Big Odd; numbers 1, 3, 5 to 13 are Small Odd.",
  "5.定位玩法(单点数字玩法)": "5. Number selection (single-number bets)",
  "从数字0-27中选取一个数字下注，如选取下注的数字与开奖如果相同，即为中奖。": "Choose one number from 0-27. You win when your number matches the result.",
  "6.波色": "6. Color bets",
  "* 绿波号码：1 , 4 , 7 , 10 , 16 , 19 , 22 , 25": "* Green numbers: 1, 4, 7, 10, 16, 19, 22, 25",
  "* 蓝波号码：2 , 5 , 8 , 11 , 17 , 20 , 23 , 26": "* Blue numbers: 2, 5, 8, 11, 17, 20, 23, 26",
  "* 红波号码：3 , 6 , 9 , 12 , 15 , 18 , 21 , 24": "* Red numbers: 3, 6, 9, 12, 15, 18, 21, 24",
  "* 当开奖结果为：0,13,14,27(所有买的波色皆输)视为全部不中奖！": "* If the result is 0, 13, 14 or 27, all color bets lose.",
  "7.豹子  顺子  对子": "7. Triples, straights and pairs",
  "当期3个开奖号码一致则中奖 , 如当期开奖结果为 3+3+3=9 则中奖豹子。": "All three numbers matching wins a triple; for example, 3+3+3=9 wins a triple bet.",
  "当期3个开奖号码顺子则中奖，如当期开奖结果为 1+2+3=6 则中奖顺子。": "Three consecutive numbers win a straight; for example, 1+2+3=6 wins a straight bet.",
  "当期3个开奖号码有两个一致中奖，如当期开奖结果为 0+2+2=4 则中奖对子。": "Two matching numbers win a pair; for example, 0+2+2=4 wins a pair bet.",
  "已经是最后一页啦！": "You are already on the last page!",
  "用户名长度6~16位，以字母或数字组合！": "Username must be 6-16 letters or numbers!",
  "请输入正确的密码长度，最少6位！": "Please enter a password of at least 6 characters!",
  "密码错误，请重新输入": "Incorrect password. Please try again.",
  "账户登录": "Account login",
  "请输入账号": "Please enter an account",
  "验证码": "Verification code",
  "记住密码": "Remember password",
  "跳过登录，先去逛逛": "Skip login and browse first",
  "新用户注册": "New user registration",
  "请输入短信验证码": "Please enter the SMS verification code",
  "获取验证码": "Get verification code",
  "切换线路": "Switch line",
  "请输入您的账号和密码！": "Please enter your account and password!",
  "OB电子": "OB Slots",
  "FG电子": "FG Slots",
  "PP电子": "PP Slots",
  "AE电子": "AE Slots",
  "始": "Start",
  "开": "Open",
  "包": "Packet",
  "红": "Red",
  "离": "Away",
  "距": "Distance",
  "束": "End",
  "结": "Finish",
  "完": "Complete",
  "抢": "Claim",
  "已": "Already",
  "已领取": "Claimed",
  "当前最多可领取": "Maximum claimable now",
  "快去满足条件吧！": "Complete the requirements to continue!",
  "活动时间": "Promotion period",
  "累计充值金额": "Cumulative deposits",
  "红包次数": "Red packet chances",
  "领取规则": "Claim rules",
  "抢到红包后，系统自动派彩，": "After claiming a red packet, the prize is credited automatically,",
  "秒到账": "credited in seconds",
  "，达到流水倍数即可取款；": ", withdraw after meeting the wagering requirement;",
  "2.领取红包条件：充值金额需要在规定的活动日期（美东时间）范围内，根据充值累计金额，获取抢红包次数，即可抢对应次数的红包；": "2. Red packet eligibility: deposit during the promotion period (Eastern Time) to earn chances based on your cumulative deposit.",
  "南宫集团官网": "Nangong official website",
  "注意": "Notice",
  "抢红包": "Claim red packet",
  "北京时间为每天早上10点到12点，存款计算为前一天12点到今天10点，谢谢~": "Beijing time is 10:00-12:00 daily. Deposits are counted from 12:00 yesterday to 10:00 today.",
  "每日百万现金红包！存款越多，机会越多，红包享不停，惊喜抢不停，还等什么？快快叫上好友一起分享吧！！": "Daily cash red packets! The more you deposit, the more chances you get. Share with friends and enjoy the surprises!",
  "1、会员必须在指定的活动日期（美东时间）范围内，根据充值累计金额，即可获得对应抢红包次数。若在规定的时间范围内没有达到存款金额范围，则不计算抢红包次数，逾期作废！": "1. Members must deposit within the specified promotion period (Eastern Time) to earn red packet chances. Deposits outside the required range do not count and expire.",
  "2、所有的活动优惠特为玩家而设，如发现任何团体或个人，以不诚实的方式套取红利或任何威胁、滥用公司优惠等行为，公司保留冻结、取消该团体或个人账户及账户结余的权利。": "2. Promotions are for players. We may freeze or cancel accounts and balances involved in bonus abuse or dishonest activity.",
  "3、金沙集团官网保留所有解释权，在任何时候都可以更改、停止、取消优惠活动。": "3. The platform reserves the right to change, suspend or cancel promotions at any time.",
  "当前时间段": "Current time period",
  "活动还没开始，请静待活动开始。": "The promotion has not started. Please wait.",
  "请静待下次活动。": "Please wait for the next promotion.",
  "恭喜您": "Congratulations",
  "抢到": "Claimed",
  "立即充值": "Deposit now",
  "您暂未达到领取条件，快去完成吧！": "You do not meet the claim requirements yet. Complete them now!",
  "服务器异常，请稍后再试": "Server error. Please try again later.",
  "软件APP": "App",
  "按照": "Follow",
  "到您的桌面": "to your desktop",
  "安装": "Install",
  "请先登录": "Please log in first",
  "PC彩票": "PC Lottery",
  "万美元": "ten thousand US dollars",
  "现在就成为赢家": "Become a winner now",
  "开始": "Start",
  "最新投注": "Latest bets",
  "最新": "Latest",
  "日榜": "Daily",
  "周榜": "Weekly",
  "月榜": "Monthly",
  "经典": "Classic",
  "百家乐": "Baccarat",
  "快速": "Quick",
  "大富翁": "Monopoly",
  "财神驾到": "God of Wealth",
  "红包派对": "Red Packet Party",
  "沙巴体育": "Saba Sports",
  "UP体育": "UP Sports",
  "德州扑克": "Texas Hold'em",
  "21点": "Blackjack",
  "抢庄牛牛": "Bull Bull",
  "巴沙体育": "Basha Sports",
  "游戏": "Games",
  "玩家": "Players",
  "倍数": "Multiplier",
  "返奖": "Payout",
  "更多": "More",
  "热门": "Popular",
  "即将上线，敬请期待": "Coming soon. Stay tuned.",
  "立即投注": "Bet now",
  "游戏厂商": "Game providers",
  "183款游戏": "183 games",
  "千人在线畅玩": "Thousands of players online",
  "最佳加密货币赌场 - 欢迎来到": "Best crypto casino - welcome to",
  "home-detail-content": "Explore the ultimate destination for crypto gaming. Every transaction here is transparent and public, and the fairness of every game can be verified. • MI28 Casino is committed to providing a safe, reliable, and fair gaming environment for every user.",
  "收起更多": "Collapse",
  "查看更多": "View more",
  "支持/法律": "Support / Legal",
  "常见问题": "Frequently asked questions",
  "负责任博彩": "Responsible gaming",
  "公平公正": "Fair and impartial",
  "服务条款": "Terms of service",
  "隐私政策": "Privacy policy",
  "关于我们": "About us",
  "支持的币种": "Supported currencies",
  "赞助和博彩责任": "Sponsorship and responsible gaming",
  "introduce1": "MI28 is owned and operated by BETMGM LLC, a company registered in Delaware, USA, company number 7061304, with its registered address in the Marina District of Atlantic City, New Jersey, USA, and conducts online business based on MGM Resorts' offline resources.",
  "introduce2": "BetMGM holds official gambling operating licenses in multiple compliant U.S. states and overseas regions. Some of the publicly verifiable core licenses are as follows:",
  "introduce3": "New Jersey: Issued by the New Jersey Division of Gaming Enforcement, license number NJIGP 000105-001, one of its earliest core operating licenses.",
  "introduce4": "Nevada: Issued by the Nevada Gaming Control Board, holding a full-service sports betting license.",
  "introduce5": "United Kingdom: Holds a remote gambling license issued by the UK Gambling Commission, license number 042596.",
  "introduce6": "MI28 is committed to providing all users with a safe, reliable and fair gaming environment. Whether betting, playing slots, or participating in live or other games, you can rest assured that MI28 operates with integrity and provides every player with an excellent gaming experience.",
  "尊敬的NG娱乐会员:": "Dear NG Entertainment member:",
  "我知道了": "Got it",
  "如何安装": "How to install",
  "1、使用Safar浏览器打开网站": "1. Open the website with Safari.",
  "2、点击分享图标": "2. Tap the Share icon.",
  "3、选择“添加到主屏幕”": "3. Choose “Add to Home Screen”.",
  "添加到主屏幕": "Add to Home Screen",
  "期开奖": "draw result",
  "账户余额": "Account balance",
  "封盘中禁止投注": "Betting is closed",
  "请输入文字指令下注": "Enter a text command to place a bet",
  "发送": "Send",
  "信用投注": "Credit betting",
  "共": "Total",
  "合计": "Subtotal",
  "最近投注": "Recent bets",
  "投注确认": "Bet confirmation",
  "游戏平台": "Game platform",
  "免转模式": "No-transfer mode",
  "额度转换": "Amount conversion",
  "平台账户余额": "Platform balance",
  "游戏账户余额": "Game account balance",
  "操作金额": "Operation amount",
  "填写操作金额": "Enter the operation amount",
  "转账方式": "Transfer method",
  "提交": "Submit",
  "充值信息": "Deposit information",
  "请在": "Please complete payment within",
  "内完成支付": "to complete payment",
  "成功付款后，将自动到账！": "After successful payment, the funds arrive automatically!",
  "如有问题，请": "If you have questions, please",
  "确认": "Confirm",
  "收款地址": "Receiving address",
  "交易时间": "Transaction time",
  "充值方式": "Deposit method",
  "充值完成": "Deposit complete",
  "资金明细": "Fund details",
  "支付方式": "Payment method",
  "银行卡": "Bank card",
  "余额充值": "Balance deposit",
  "请输入充值金额": "Please enter a deposit amount",
  "充值限额：": "Deposit limit:",
  "请设置密码": "Set a password",
  "注册并下载APP": "Register and download the app",
  "两次密码不一样！": "The passwords do not match!",
  "请输入验证码！": "Please enter the verification code!",
  "验证码错误！": "Incorrect verification code!",
  "注册失败": "Registration failed",
  "获取验证码...": "Getting verification code...",
  "请阅读并同意相关条款和隐私协议！": "Please read and agree to the terms and privacy policy!",
  "两次密码不一致！": "The passwords do not match!",
  "请输入您的真实姓名!": "Please enter your real name!",
  "请输入正确的支付密码长度，最少6位！": "Please enter a payment password of at least 6 characters!",
  "卡片管理": "Card management",
  "虚拟币": "Cryptocurrency",
  "最多支持添加5张银行卡": "You can add up to 5 bank cards",
  "确定要解除绑定该卡片吗？": "Unbind this card?",
  "解绑成功": "Unbound successfully",
  "(几分钟到数十分钟)": "(several minutes to tens of minutes)",
  "(几秒到几分钟)": "(a few seconds to a few minutes)",
  "*两种协议对应的USDT地址不互通，进行转账、充值等操作时，应仔细核对正确地址！": "*USDT addresses for the two protocols are not interchangeable. Verify the address before transferring or depositing.",
  "1. 点击我的 (个人信息)": "1. Tap My (Personal information)",
  "1.第一次提现到数字货币时，请先绑定提币地址，绑定提币地址的步骤：": "1. Before your first crypto withdrawal, bind a withdrawal address:",
  "1.请注意，注册时要求填写真实而准确的信息。": "1. Please provide true and accurate information when registering.",
  "2. 卡片管理": "2. Card management",
  "2.用户使用网站前，请务必先阅读规则与条款，并确定已年满18岁。": "2. Read the rules and terms and confirm that you are at least 18 before using the site.",
  "2.输入提币金额，点击‘立即取款’，提币申请提交成功": "2. Enter the withdrawal amount and tap “Withdraw now” to submit the request.",
  "2007-08赛季，尼克·杨代表奇才队出战75场常规赛比赛，场均得到7.5分、1.5个篮板。": "In the 2007–08 season, Nick Young played 75 regular-season games for Washington, averaging 7.5 points and 1.5 rebounds.",
  "2007年NBA选秀，尼克·杨在第一轮第16顺位被华盛顿奇才队选中。": "Nick Young was selected 16th overall by Washington in the first round of the 2007 NBA Draft.",
  "2008-09赛季，由于奇才后场大将吉尔伯特·阿里纳斯的报销，尼克·杨获得了更多的机会，出战82场首发5次，场均得到10.9分。": "In 2008–09, Nick Young received more opportunities after Gilbert Arenas was sidelined, appearing in 82 games with five starts and averaging 10.9 points.",
  "2009-10赛季，奇才后场补充了兰迪·弗耶、迈克·米勒等优秀球员，抢占了尼克·杨的出场时间，尼克·杨出战74场比赛，场均得到8.6分": "In 2009–10, Washington added Randy Foye and Mike Miller, reducing Young’s playing time; he appeared in 74 games and averaged 8.6 points.",
  "3. 添加虚拟币地址": "3. Add a cryptocurrency address",
  "3.提币审核成功后请登录交易网站或数字货币官方网站核实到账金额": "3. After approval, check the credited amount on your exchange or the official cryptocurrency site.",
  "4. 填写虚拟币地址信息": "4. Enter the cryptocurrency address information",
  "5. 选择虚拟币提现/立即取款": "5. Select cryptocurrency withdrawal / Withdraw now",
  "6. 等待审核": "6. Wait for review",
  "ERC20-USDT地址以0x开头": "ERC20 USDT addresses start with 0x",
  "ERC20协议": "ERC20 protocol",
  "ERC20：基于以太坊网络协议": "ERC20: based on the Ethereum network protocol",
  "Hi，欢迎进入{title}": "Hi, welcome to {title}",
  "TRC20-USDT地址以T开头": "TRC20 USDT addresses start with T",
  "TRC20协议": "TRC20 protocol",
  "TRC20的提币手续费最低，这意味着用户可以享受低手续费的交易所提币服务。同时，波场网络的TPS能够达到上千级别，可以实现交易秒级确认。": "TRC20 has the lowest withdrawal fee. Its high network throughput can confirm transactions in seconds.",
  "TRC20：基于波场网络协议": "TRC20: based on the TRON network protocol",
  "Luka赞助内容": "In June 2019, Luka Doncic partnered with {title} as an official ambassador. Together, {title} and Luka Doncic aim to build a new global sports leader.",
  "专属VIP体验": "Exclusive VIP experience",
  "个人简介": "Profile",
  "中等额度": "Medium amount",
  "中等额度推荐": "Recommended for medium amounts",
  "交易推荐": "Recommended for regular transactions",
  "交易记录": "Transaction history",
  "享受只属于你的与众不同": "Enjoy benefits made uniquely for you",
  "今日收益": "Today's profit",
  "代理加盟": "Agent partnership",
  "代理登录": "Agent login",
  "以太坊发行自己的原生代币及其他代币。但成千上万种代币的规则都不一样，这对后期市场发展非常不利。所以代币发行者做了一个智能合约标准，也就是ERC20。": "Ethereum issues its native token and other tokens. Issuers created the ERC20 smart-contract standard.",
  "以太坊网络": "Ethereum network",
  "会员中心": "Member center",
  "会员教程": "Member guide",
  "低": "Low",
  "低手续费，秒级到账。": "Low fee, credited within seconds.",
  "体育游戏规则": "Sports betting rules",
  "使用建议": "Usage recommendation",
  "使用网络": "Network",
  "充值前": "Before depositing",
  "充值后": "After depositing",
  "充值教程": "Deposit guide",
  "充值时间": "Deposit time",
  "充值金额": "Deposit amount",
  "免责说明": "Disclaimer",
  "分享链接": "Share link",
  "到底选哪种协议更好？": "Which protocol should I choose?",
  "前往领取": "Claim now",
  "加入{title}第{days}天": "Day {days} with {title}",
  "加入我们，共赢财富": "Join us and grow together",
  "区别点": "Comparison",
  "协议介绍": "Protocol introduction",
  "博彩责任": "Responsible gaming",
  "历史收益": "Historical profit",
  "地址样式": "Address format",
  "场馆余额": "Venue balance",
  "基本不堵": "Rarely congested",
  "复制成功！": "Copied successfully!",
  "好友接受": "Friend accepts",
  "好友进行": "Friend deposits and bets",
  "如何注册": "How to register",
  "存款投注": "Deposit and bet",
  "安全系数": "Security",
  "安全退出": "Sign out safely",
  "官方全球顶级合作伙伴": "Official global top partner",
  "官方区域合作伙伴": "Official regional partner",
  "尊敬的会员用户": "Dear member",
  "小额交易推荐": "Recommended for small amounts",
  "小额高频": "Small, frequent transactions",
  "尤文图斯": "Juventus",
  "已领取次数": "Times claimed",
  "帮助中心": "Help center",
  "常规交易推荐": "Recommended for regular transactions",
  "彩票投注规则": "Lottery betting rules",
  "得分": "Score",
  "得分：{score}": "Score: {score}",
  "总投注额": "Total bet",
  "总资产": "Total assets",
  "您的邀请": "Your invitation",
  "意见反馈": "Feedback",
  "手机号码注册": "Register with phone number",
  "手机号码注册-输入手机号码，并验证码手机号码。": "Phone registration: enter and verify your phone number.",
  "手续费和速度都介于中间值。": "Fee and speed are between the two options.",
  "手续费用": "Fee",
  "投注前": "Before betting",
  "投注后": "After betting",
  "捕鱼": "Fishing",
  "提现前，请先确保您已成功登录账号。": "Before withdrawing, make sure you are logged in.",
  "提现教程": "Withdrawal guide",
  "早上好，欢迎来到帮助中心": "Good morning, welcome to the help center",
  "时间排行榜": "Time rankings",
  "时间：{time}": "Time: {time}",
  "普通": "Standard",
  "更多公告": "More announcements",
  "有效流水": "Valid turnover",
  "期数": "Period",
  "未登录": "Not logged in",
  "条款协议内容": "Terms and conditions",
  "极快": "Very fast",
  "欢迎来到{title}": "Welcome to {title}",
  "欢迎来到平台，我们致力于通过精良的技术、前卫的产品，成为亚洲博彩业的领导品牌": "Welcome to our platform through strong technology and forward-looking products.",
  "步骤如下": "Steps",
  "永久域名": "Permanent domain",
  "没有找到解决办法？请联系": "Could not find a solution? Contact ",
  "波场网络": "TRON network",
  "活动时间: 长期有效": "Promotion period: ongoing",
  "活动记录": "Activity history",
  "游戏排行榜": "Game rankings",
  "游戏规则_体育内容": "<div class=\"sports-games-article\"><div class=\"main-container-title\">General sports rules</div><div class=\"main-container-content\"><p>All bets follow these terms. Review each market before submitting. Cancelled or delayed events may be voided according to the applicable rules.</p><ol><li>Review selections before submitting.</li><li>Submitted bets cannot be changed or cancelled.</li><li>Official results and platform records are final for settlement.</li><li>Live bets may be delayed or rejected after a material event.</li></ol></div></div>",
  "游戏规则_彩票内容": "<div class=\"lottery-games-article\"><div class=\"main-container-title\">Lottery rules</div><div class=\"main-container-content\"><p>Lottery markets are settled using the official draw result. Review the market definition, closing time and payout conditions before betting.</p><p>Void, cancelled or delayed draws follow the applicable market rules.</p></div></div>",
  "游戏规则_电子游戏内容": "<div class=\"electron-games-article\"><div class=\"main-container-title\">Electronic game rules</div><div class=\"main-container-content\"><p>{brand} electronic games use certified random outcomes. Play responsibly and review the paytable before betting.</p><p>Results are settled according to the displayed rules and the platform record.</p></div></div>",
  "游戏规则_真人内容": "<div class=\"immortal-games-article\"><div class=\"main-container-title\">Live casino rules</div><div class=\"main-container-content\"><p>Live roulette, baccarat and dice games are operated by a live dealer. Select a market and submit your stake before betting closes.</p><p>Rules, payouts and settlement conditions are displayed for each table.</p></div></div>",
  "电子游戏规则": "Electronic game rules",
  "登录后查看": "Log in to view",
  "登录平台-个人信息-卡片管理-添加数字货币地址": "Platform - Personal information - Card management - Add cryptocurrency address",
  "真人娱乐规则": "Live casino rules",
  "真人娱乐，体育投注，电子游艺等尽在一手掌握": "Live casino, sports betting and electronic games in one place",
  "福利中心": "Welfare center",
  "立享会员特权": "Enjoy member privileges now",
  "立即登录": "Log in now",
  "第一步：在网站或App上直接点击注册；": "Step 1: Tap Register on the website or app.",
  "第三步：按照提示填写资料；": "Step 3: Follow the prompts to complete your details.",
  "第三步：设置账户昵称": "Step 3: Set an account nickname",
  "第二步：按照提示填写资料；": "Step 2: Follow the prompts to complete your details.",
  "第二步：按照提示填写资料；；": "Step 2: Follow the prompts to complete your details.",
  "第五步：注册成功。": "Step 5: Registration complete.",
  "第四步：注册成功": "Step 4: Registration complete",
  "第四步：设置账户昵称。": "Step 4: Set an account nickname.",
  "等级": "Level",
  "等级排行榜": "Level rankings",
  "等级：{level}": "Level: {level}",
  "红包记录": "Red-packet history",
  "红包金额": "Red-packet amount",
  "经常拥堵": "Often congested",
  "给你好友": "To your friends",
  "网络状态": "Network status",
  "联系我们": "Contact us",
  "至": "to",
  "若相关问题仍未解决，可咨询在线客服": "If the issue remains unresolved, contact online support.",
  "虚拟币提现": "Cryptocurrency withdrawal",
  "虚拟币支付": "Cryptocurrency payment",
  "设置登录密码。": "Set a login password.",
  "豪礼赠送": "Gifts",
  "账户名注册": "Register with username",
  "账户名注册-输入账户名和密码。。": "Username registration: enter a username and password.",
  "账户设置": "Account settings",
  "购买虚拟币": "Buy cryptocurrency",
  "赞助": "Sponsors",
  "赞助信息": "Sponsorship",
  "转账速度": "Transfer speed",
  "退出系统": "Exit",
  "选择数字货币": "Select cryptocurrency",
  "邀请有好礼 红包等你": "Invite friends and claim red packets",
  "阿斯顿维拉": "Aston Villa",
  "隐私政策提示": "Privacy policy notice",
  "高": "High",
  "1. 打开并登录欧意APP": "1. Open and sign in to the OKX app",
  "1. 选择数字货币": "1. Select cryptocurrency",
  "2. 输入充值金额": "2. Enter the deposit amount",
  "2. 选择快捷买币": "2. Choose quick buy",
  "3. 复制地址或进行扫码": "3. Copy the address or scan the QR code",
  "3. 点击去购买": "3. Tap Buy now",
  "4. 打开并登录欧易软件": "4. Open and sign in to the exchange app",
  "4. 输入购买金额": "4. Enter the purchase amount",
  "5. 可持续二次购买": "5. You can make another purchase",
  "5. 进入“资金”选择“提现”": "5. Open Funds and select Withdraw",
  "6. 选择USDT币种": "6. Select USDT",
  "7. 点击提交按钮": "7. Tap Submit",
  "VIP收益": "VIP profit",
  "参与期数": "Participating periods",
  "团队俑金返水": "Team commission rebate",
  "团队彩金": "Team bonus",
  "团队总剩余": "Team balance",
  "团队总提现": "Team withdrawals",
  "团队总流水": "Team turnover",
  "团队总盈利": "Team profit",
  "团队退水": "Team refund",
  "当前游戏无房间": "No rooms are available for this game",
  "条款与规则": "Terms and rules",
  "消息": "Messages",
  "玩家详情": "Player details",
  "虚拟货币支付": "Cryptocurrency payment",
  "返点收益": "Rebate income",
  "香港六合彩": "Hong Kong Mark Six",
  "AG真人": "AG Casino",
  "AG电子": "AG Electronic",
  "BG真人": "BG Casino",
  "FB体育": "FB Sports",
  "KY棋牌": "KY Chess",
  "PG电子": "PG Slots",
  "专业模式": "Professional mode",
  "群控模式": "Group mode",
  "进入游戏": "Enter game",
  "大厅选择": "Hall selection",
  "选择房间": "Room selection",
  "房间规则": "Room rules",
  "新手推荐": "New user recommended",
  "最热门": "Most popular",
  "VIP专属": "VIP exclusive",
  "MI28-中级": "MI28 - Intermediate",
  "MI28-高级": "MI28 - Advanced",
  "MI28-5分钟": "MI28 - 5 minutes",
  "MI28-5分钟-中级": "MI28 - 5 minutes - Intermediate",
  "MI28-5分钟-高级": "MI28 - 5 minutes - Advanced",
  "房间规则1": "1. VIP 1 is suitable for new players",
  "房间规则2": "2. VIP 2 offers higher odds for advanced players",
  "房间规则3": "3. VIP 3 offers the highest odds and exclusive service",
  "分钟": "Min",
};



// WEBPACK FOOTER //
// ./src/locales/lang/en.js